import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $stateParams) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.errorMsg = $stateParams.errorMsg;
        $scope.quoteID = $stateParams.quoteID;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/controllers/ContactUsCtrl.js
// module id = 836
// module chunks = 0